<template>
    <flex-element :element-type="elementType" class="fc-icon f-flex f-items-center f-cursor-pointer">
        <a-link v-bind="element(1)" @element-updated="elementUpdated">
            <slot />
        </a-link>

        <a-icon
            class="fc-icon__arrow"
            set="fal"
            icon="long-arrow-right"
            v-bind="element(2)"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import Organism from '@/mixins/base-organism/base-organism-dumb';

export default {
    mixins: [Organism],
};
</script>

<style lang="scss" scoped>
.fc-icon {
    $this: &;

    &__arrow {
        transition: all 0.3s ease;

        #{ $this }:hover & {
            transform: translateX(8px);
        }
    }
}
</style>
